/**
 * The three marks an answer can earn, in the words a student sees. The
 * content calls them strong, adequate and weak; the screen never shows those
 * keys, or any other term from how the questions are built, without saying
 * what the mark means.
 */
export const MARKS = {
  strong: {
    label: 'Strong',
    description: 'Gets to what the question was really asking, with specific, well-reasoned points.',
  },
  adequate: {
    label: 'Good',
    description: 'Sound and relevant, but missing some depth, precision or a key step.',
  },
  weak: {
    label: 'Needs work',
    description: 'Misses the main point, stays vague, or contains an error.',
  },
};

export const MARK_ORDER = ['strong', 'adequate', 'weak'];

export function markLabel(key) {
  return MARKS[key]?.label || 'Not answered';
}
